module.exports = function() {
  return new Worker(__webpack_public_path__ + "ed9c0b0a86f1ba6976ca.worker.js");
};